export default __webpack_public_path__ + "static/img-cs-zappi-timeline-ac3698e22ad707348712d6f6431dcead.png";